import React,{useState,useEffect} from 'react'
import HeaderAdmin from "../../Components/HeaderAdmin";
import AddItemModal from "../../Components/Menu/AddItemModal";
import AddCategoriaModal from "../../Components/Menu/AddCategoriaModal";
import useCategorias from '../../Hooks/useCategorias';
import {Fab} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import usePrivilegios from '../../Hooks/usePrivilegios';
import ItemsBusquedas from '../../Components/Menu/ItemsBusquedas';
import Input from '../../Components/Input';
import { useHistory } from 'react-router-dom';
import Categorias from '../../Components/Menu/Categorias';


const Menu = () => 
{
    usePrivilegios();
    const History=useHistory();
    // const Categorias=useCategorias();
    const [openAddCategoria, setopenAddCategoria] = useState(false);
    const [openAddItem, setopenAddItem] = useState(false);
    const [StringBusqueda, setStringBusqueda] = useState("");

    useEffect(() => 
    {
        document.title="Baum Lanús - Menú"
    }, [])


    const Styles=
    {
        fabStyle:
        {
            display:"flex",
            backgroundColor:"#0088FF",
            color:"white",
            margin:"10px auto"
        },
        Container:
        {
            position:"fixed",
            bottom:10,
            right:10,
            color:"white"
        }
    }

    // const CategoriasList=()=>
    // {
    //     if(Categorias.length===0)
    //     {
    //         return <Loader/>
    //     }
    //     else
    //     {
    //         return <>
    //         {Categorias.map(categoria => 
    //             {
    //                 return <>
    //                 <Categoria categoria={categoria}/>
    //                 <Divider/>
    //                 </>
    //             })}
    //         </>
    //     }
    // }

    const changeStatusCategoria=()=>
    {
        setopenAddCategoria(!openAddCategoria);
    }
    
    const changeStatusItem=()=>
    {
        History.push("/admin/menu/nuevo");
    }

    const ButtonsAdd=()=>
    {
        return <div style={Styles.Container}>
            <Fab style={Styles.fabStyle} variant="extended" onClick={changeStatusCategoria}> 
               <AddIcon/>
               Categoría
            </Fab>
            <Fab style={Styles.fabStyle} variant="extended" onClick={changeStatusItem}>
               <AddIcon/>
               Item
            </Fab>
        </div>
    }

    const Busqueda=()=>
    {
        if(StringBusqueda.length>0)
        {
            return <ItemsBusquedas string={StringBusqueda}/>;

        }
        return <div>
            <Categorias/>
            <ButtonsAdd/>
        </div>
    }

    return <div>
        <HeaderAdmin title={"Menú"}/>
            <Input Busqueda={true}  value={StringBusqueda} changeValue={setStringBusqueda} styleCSS={{padding:"20px"}}/>
        <Busqueda/>
    <AddItemModal open={openAddItem} close={changeStatusItem}/>
    <AddCategoriaModal open={openAddCategoria} close={changeStatusCategoria}/>
    </div>
}

export default Menu
